import { SET_WINDOW_SIZE } from './app.actions'

export { SET_WINDOW_SIZE }
